import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionSummary, AccordionDetails, Box, Checkbox, Typography, useTheme, alpha } from '@mui/material';
import { Icon } from '@iconify/react';
import DocumentFileItem from './DocumentFileItem';
import AssetFolderIcon from '../../../../icons/components/asset-folder-icon';
var FolderModelAccordion = function (_a) {
    var modelNumber = _a.modelNumber, size = _a.size, isXs = _a.isXs, files = _a.files, isExpanded = _a.isExpanded, isSelected = _a.isSelected, selectedFiles = _a.selectedFiles, fileVisibility = _a.fileVisibility, onToggleExpanded = _a.onToggleExpanded, onToggleSelect = _a.onToggleSelect, onFileToggleSelect = _a.onFileToggleSelect, onFileToggleVisibility = _a.onFileToggleVisibility;
    var theme = useTheme();
    return (_jsxs(Accordion, { expanded: isExpanded, onChange: onToggleExpanded, disableGutters: true, sx: {
            width: '100%',
            boxShadow: isExpanded ? '0px 8px 16px 0px rgba(145, 158, 171, 0.16)' : 'none',
            borderRadius: '8px',
            position: 'relative',
            backgroundColor: '#FFFFFF',
            borderTop: !isExpanded ? "1px solid ".concat(alpha(theme.palette.divider, 0.2)) : 'none',
            '&.Mui-expanded': {
                margin: 0
            }
        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(Icon, { icon: 'eva:arrow-ios-downward-fill', width: 20, height: 20 }), sx: {
                    padding: '12px 8px 12px 16px',
                    minHeight: 'auto',
                    '& .MuiAccordionSummary-content': {
                        margin: 0,
                        alignItems: 'center'
                    }
                }, children: _jsxs(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        width: '100%'
                    }, children: [_jsx(Checkbox, { checked: isSelected, onChange: function (e) {
                                e.stopPropagation();
                                onToggleSelect();
                            }, onClick: function (e) { return e.stopPropagation(); }, color: 'primary', size: 'small', sx: { padding: '8px' } }), _jsxs(Box, { display: 'flex', flex: 1, minWidth: 0, gap: 1, alignItems: 'center', children: [_jsx(AssetFolderIcon, { width: isXs ? 20 : 24, height: isXs ? 20 : 24, color1: '#ddb94d', color2: '#FFCF5C', color3: '#FFCF5C', style: { flexShrink: 0 } }), _jsx(Typography, { variant: 'subtitle1', color: 'text.primary', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: modelNumber })] }), _jsx(Typography, { variant: 'body1', color: 'text.secondary', sx: {
                                marginLeft: 'auto',
                                pr: 0.5
                            }, children: size })] }) }), isExpanded && (_jsx(AccordionDetails, { sx: {
                    padding: '8px 16px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px'
                }, children: _jsx(Box, { children: files.map(function (file, index) {
                        var _a;
                        return (_jsx(Box, { sx: {
                                position: 'relative',
                                ml: isXs ? 0 : 2,
                                '&:before': {
                                    content: '""',
                                    position: 'absolute',
                                    left: isXs ? '14px' : '0px',
                                    top: '-2px',
                                    width: '2px',
                                    borderLeft: '2px dashed #637381',
                                    height: index === files.length - 1 ? '23px' : 'calc(100% + 38px)'
                                },
                                '&:after': {
                                    content: '""',
                                    position: 'absolute',
                                    left: isXs ? '17px' : '2px',
                                    top: '35px',
                                    width: isXs ? '14px' : '24px',
                                    borderTop: '2px dashed #637381'
                                }
                            }, children: _jsx(DocumentFileItem, { id: file.id, fileName: file.fileName, fileSize: file.fileSize, isSelected: selectedFiles.has(file.id), isPublic: (_a = fileVisibility[file.id]) !== null && _a !== void 0 ? _a : file.isPublic, onToggleSelect: onFileToggleSelect, onToggleVisibility: onFileToggleVisibility }) }, file.id));
                    }) }) }))] }));
};
export default FolderModelAccordion;
